module.exports = {
    captcha_v3_public_key: "6LfFUgUfAAAAANIiBGYx8G4MddY1MhrM_V-Q88Ns"
};